import { useEffect, useState } from "react";

const links = [
  { href: "#top", label: "首页" },
  { href: "#pick", label: "治愈精选" },
  { href: "#list", label: "番剧合集" },
  { href: "#pian", label: "片单合集" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-movie-2-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl ${
              scrolled || open ? "text-primary-700" : "text-background-50"
            }`}
          >
            小狗看番
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700"
                  : "text-background-100 hover:bg-white/10 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#pian"
            className={`ml-3 rounded-md px-4 py-2 text-sm whitespace-nowrap transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-white/90 text-primary-700 hover:bg-white"
            }`}
          >
            一键追番
          </a>
        </nav>

        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-9 w-9 items-center justify-center rounded-md md:hidden ${
            scrolled || open ? "text-foreground-800" : "text-background-50"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 pb-4 md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#pian"
            onClick={() => setOpen(false)}
            className="mt-2 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm text-background-50 hover:bg-primary-600"
          >
            一键追番
          </a>
        </nav>
      )}
    </header>
  );
}